import React, { FC, useContext, useState } from 'react';
import { ValidationsContext } from './ValidationsContext';
import { FlexGroup, FlexItem, ComboFilter, ComboFilterCategory, Loading } from '@lithos';
import { TimeSelector } from '@tecton';

interface ValidationsControlsProps {
  hasAnyFilters: boolean;
  activeFilterCount: number;
  handleResetFilters: () => void;
  categories: ComboFilterCategory[];
  isLoading: boolean;
}

const ValidationsControls: FC<ValidationsControlsProps> = ({
  hasAnyFilters,
  activeFilterCount,
  handleResetFilters,
  categories,
  isLoading,
}) => {
  const context = useContext(ValidationsContext);
  const [selectedCategory, setSelectedCategory] = useState<ComboFilterCategory | undefined>(undefined);

  return (
    <FlexGroup alignItems="center" padding="0">
      <FlexItem grow={0}>
        <TimeSelector
          onSelection={(start, end) => {
            context.updateFilters({
              ...context.filterState,
              startDate: start,
              endDate: end,
            });
          }}
          defaultValue={'2Weeks'}
        />
      </FlexItem>
      <FlexItem grow={1}>
        <ComboFilter
          icon={'Filters'}
          hasAnyActiveFilters={hasAnyFilters}
          activeFilterCount={activeFilterCount}
          resetFilters={handleResetFilters}
          categories={categories}
          setSelectedCategory={setSelectedCategory}
          selectedCategory={selectedCategory}
        />
      </FlexItem>
      <FlexItem grow={0}>{isLoading && <Loading />}</FlexItem>
    </FlexGroup>
  );
};

export default ValidationsControls;
